import type { FaireProductEntity } from "../../entity_types/product";

export const p_8pxfmcv78n: FaireProductEntity = {
  token: "p_8pxfmcv78n",
  type: "product",
  name: "Gold Heart Layering Necklace, Dainty Necklace, Sku#Z711",
  brandToken: "b_4f46qpq5wu",
  brandName: "BestBeads&Beyond",
  imageUrl:
    "https://cdn.faire.com/fastly/3ef5f503cde0089e0403328c31f2b087daac807677db98ab10ca45d8c8683ad5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cecbe9972bc4bb17daa8248b68022fb510ff23cbd2ecd5c6c8c6e32b6e55daa9.jpeg",
    "https://cdn.faire.com/fastly/d2465a38fe69d321b92394acd27e989dcacf11795fe84aac0403171c22ac3a8f.jpeg",
    "https://cdn.faire.com/fastly/d40dc32cc4bc13ea9c8c1824c1c48cd965b352ab2d537765294ec6238f198397.jpeg",
    "https://cdn.faire.com/fastly/ead7ca13aa1b0b637e2910fc19bdde61e9a73d30dfec960cd38f649feb90af3e.jpeg",
  ],
  priceDollars: 15.64,
  description:
    'Discover a classic piece from BestBeads&Beyond with the Gold Heart Layering Necklace. This dainty piece is perfect for everyday wear or for special occasions. With a 16" adjustable length, it offers versatility to suit any style. Despite its delicate appearance, this necklace is designed to make a statement on its own or layered with other pieces. Add a touch of elegance to your jewelry collection with this charming pendant necklace.',
  tags: [],
  msrpDollars: 31.28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:56.142Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
